import MagicLinkForm from '../forms/MagicLinkForm';

const MagicLinkForms = (props) => {
  const { redirectLink } = props;
  return (
    <div className="c7-account-login--returning-customer">
      <h4>Magic Link</h4>
      <MagicLinkForm redirectLink={redirectLink} loginLink="/profile/login" />
    </div>
  );
};

export default MagicLinkForms;
